/// <amd-module name="SuiteCommerce.LookBook.LookItem.CollectionView"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.LookItem.CollectionView", ["require", "exports", "suitecommerce_lookbook_lookitem_row.tpl", "suitecommerce_lookbook_lookitem_cell.tpl", "Backbone.CollectionView", "SuiteCommerce.LookBook.LookItem.View"], function (require, exports, lookItemRowTpl, lookItemCellTpl, BackboneCollectionView, LookItem_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookItemCollectionView = void 0;
    var LookItemCollectionView = /** @class */ (function (_super) {
        __extends(LookItemCollectionView, _super);
        function LookItemCollectionView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.childView = LookItem_View_1.LookItemView;
            _this.viewsPerRow = 3;
            _this.rowTemplate = lookItemRowTpl;
            _this.cellTemplate = lookItemCellTpl;
            return _this;
        }
        return LookItemCollectionView;
    }(BackboneCollectionView));
    exports.LookItemCollectionView = LookItemCollectionView;
});
